const MobileMessage = () => (
    <div className="mobile-message">
      <div style={{width: '80vw', textAlign: 'left', padding: '10vw', paddingBottom: 0, fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontSize: 25}}>Unfortunatly my website does not work properly on mobile :(</div>
        <div style={{width: '80vw', textAlign: 'left',paddingBottom: 0, paddingTop: 10, padding: '10vw', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontSize: 25}}>Please try again on a deskop browser instead.</div>
        <div style={{width: '80vw', textAlign: 'left', padding: '10vw', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', fontSize: 25}}>-Caden Chorlog</div>
    </div>
  );
  
  export default MobileMessage;